import { type ElementRef, useEffect, useMemo, useRef } from "react"

import type { TaskFeedback } from "@/types/taskFeedbackTypes"

import FeedbackNoteMessage from "./FeedbackNoteMessage"
import style from "./TicketsStyle.module.css"

export default function FeedbackChatContainer({
  data,
}: {
  data?: TaskFeedback[]
}) {
  const chatContainerRef = useRef<ElementRef<"div">>(null)

  const finalArr = useMemo(() => {
    if (!data) return []
    return [...data]
  }, [data])

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight
    }
  }, [finalArr])

  return (
    <div className={style["chat_con"]} ref={chatContainerRef}>
      {finalArr.map((ele, index) => {
        return (
          <div
            className="d-flex gap-3 w-full justify-content-between"
            key={index}
          >
            <FeedbackNoteMessage
              ele={ele}
              user={"agent"}
              // user={ele?.is_sender ? "user" : "agent"}
            />
          </div>
        )
      })}
    </div>
  )
}
